var _a;
export var EthereumWallet;
(function (EthereumWallet) {
    EthereumWallet[EthereumWallet["Metamask"] = 1] = "Metamask";
    EthereumWallet[EthereumWallet["WalletConnect"] = 2] = "WalletConnect";
    EthereumWallet[EthereumWallet["WalletLink"] = 3] = "WalletLink";
})(EthereumWallet || (EthereumWallet = {}));
export var ETHEREUM_WALLETS = Object.values(EthereumWallet).filter(function (v) { return !isNaN(Number(v)); });
export var SolanaWallet;
(function (SolanaWallet) {
    SolanaWallet[SolanaWallet["Phantom"] = 4] = "Phantom";
    SolanaWallet[SolanaWallet["Solflare"] = 5] = "Solflare";
})(SolanaWallet || (SolanaWallet = {}));
export var SOLANA_WALLETS = Object.values(SolanaWallet).filter(function (v) { return !isNaN(Number(v)); });
export var isEthereumWallet = function (wallet) {
    return ETHEREUM_WALLETS.includes(wallet);
};
export var isSolanaWallet = function (wallet) {
    return SOLANA_WALLETS.includes(wallet);
};
export var WALLET_TITLES = (_a = {},
    _a[EthereumWallet.Metamask] = "METAMASK",
    _a[EthereumWallet.WalletConnect] = "WALLET CONNECT",
    _a[EthereumWallet.WalletLink] = "COINBASE WALLET",
    _a[SolanaWallet.Phantom] = "PHANTOM",
    _a[SolanaWallet.Solflare] = "SOLFLARE",
    _a);
//# sourceMappingURL=wallets.js.map